<template>
        <div class="mb-1 text-base font-medium text-racing-stars-yellow">Step 4 of 14</div>
        <div class="w-full bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-700 ">
            <div class="bg-gradient-to-r from-racing-stars-yellow to-yellow-200 h-2.5 rounded-full"
                :style="{'width': 7.142857143 * 4  + '%'}"></div>
        </div>

        <p class="text-center max-w-md text-base font-normal">
            By entering this meeting you stand to win a prize of <b
                class="text-racing-stars-yellow">''</b>.</p>

        <Disclosure v-slot="{ open }">
            <DisclosureButton class="mt-1 flex w-full justify-between rounded-md bg-gray-500 px-4 py-2 text-left text-sm font-medium text-gray-200 hover:text-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
            <span>Learn more about Winnings?</span>
            <ChevronUpIcon :class="open ? 'rotate-180 text-gray-200' : ''" class="h-5 w-5 text-gray-200"/>
            </DisclosureButton>

            <transition
            enter-active-class="transition ease duration-500 transform"
            enter-from-class="opacity-0 -translate-y-4"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease duration-300 transform"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-4ray"
            >
                    <DisclosurePanel  class="px-0 pt-0 pb-0 text-sm text-gray-200">

                        <ul class="list-none p-2 pb-0 text-sm
                         max-w-md">
                            <li class="pb-2">
                                <b class="text-racing-stars-yellow   max-w-md">'Stars' </b> : Awards you with Stars for the store and meetings.
                            </li>
                            <li class="pb-2">
                                <b class="text-racing-stars-yellow   max-w-md">'Jackpot'</b> : Awards you with a cash prize.
                            </li>
                            <li class="pb-0">
                                <b class="text-racing-stars-yellow   max-w-md">'Named prize'</b> : Awards you with a prize of our choosing.
                            </li>
                        </ul>

                    </DisclosurePanel>
                </transition>
        </Disclosure>

        <button type="button" :v-model="tutorialStep" @click.stop="$emit('updateTutorialStep', (tutorialStep+=1));"
            class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-black bg-racing-stars-yellow hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
            Next step
        </button>
</template>

<script>
import Popper from 'vue3-popper'
import {Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import {ChevronUpIcon, ChevronDownIcon} from '@heroicons/vue/outline'

export default {
    props: {
        meeting: {
            type: Object,
            default: {}
        },
        tutorialStep: {
            type : Number,
        },
    },
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Popper,
        ChevronDownIcon,
        ChevronUpIcon,
    },
}

</script>
